import React, {useEffect, useState} from "react";
import {Button} from "react-bootstrap";

const ToTop = () =>{

    const [isTopState, setIsTop] = useState(true);

    useEffect(() => {
        document.addEventListener('scroll', () => {
            const isTop = window.scrollY < 600;
            if (isTopState !== isTop) {
                setIsTop(isTop)
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

        return (
            <div className={'scroll-to-top'}>
                <Button variant={'link'} className={isTopState ? 'btn-to-top' : 'btn-to-top active'} onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
                    torna su
                </Button>
            </div>
        )
}

export default ToTop;